import type { GeneralConfig } from '@shared/types/Config';

export const certifierConfig: GeneralConfig = {
    sortFieldMap: {},
};
